import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Sass/style.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LoadingProvider } from './Component/LoadingContext';
import LoadingIndicator from './Component/LoadingIndicator';
import Home from './Pages/Home';
import PrivacyPolicy from './Pages/Policy';
import Safety from './Pages/Safety';
import Blog from './Pages/Blog';
import Blog1 from './Pages/Blog1';
import Blog2 from './Pages/Blog2';
import Blog3 from './Pages/Blog3';
import Blog4 from './Pages/Blog4';
import Blog5 from './Pages/Blog5';
import Blog6 from './Pages/Blog6';
import Blog7 from './Pages/Blog7';
import './Component/i18n';
import CategoryLink from './Pages/CategoryLink';
import NextPage from './Component/CategoryLink/next';
import StepPage from './Component/CategoryLink/category3Steps';
import EmotionCard from './Component/CategoryLink/emotioncard';
import NextPageTime from './Component/CategoryLink/nexttimestamp';
import ShowCard from './Component/CategoryLink/showCard';
import HotnessCard from './Component/CategoryLink/hotnesscard';
import FriendVoice from './Component/CategoryLink/friendvoice';
import BluffCard from './Component/CategoryLink/bluffcard';
import FriendCard from './Component/CategoryLink/friendcard';
import Collab from './Pages/collab';
import { SnackbarProvider } from './Component/context/SnackbarContext';
import HellHeavenCard from './Component/CategoryLink/hellheavencard';
import { LanguageProvider } from './Component/context/Languagecontext';
import LanguageDropdown from './Component/Languagedropdown';
import ReputationCard from './Component/CategoryLink/reputationcard';
import ImpressionCard from './Component/CategoryLink/impressioncard';

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/:username/:category',
    element: <CategoryLink />,
  },
  {
    path: '/:username/:category/:timestamp',
    element: <CategoryLink />,
  },
  {
    path: '/:username/:category/next',
    element: <NextPage />,
  },
  {
    path: '/:username/:category/:timestamp/next',
    element: <NextPageTime />,
  },
  {
    path: '/:username/:category/funcards',
    element: <StepPage />,
  },
  {
    path: '/:username/:category/funcards/card',
    element: <ShowCard />,
  },
  {
    path: '/:username/:category/emotioncard',
    element: <EmotionCard />,
  },
  {
    path: '/:username/:category/hotnesscard',
    element: <HotnessCard />,
  },
  {
    path: '/:username/:category/friendvoice',
    element: <FriendVoice />,
  },
  {
    path: '/:username/:category/friendcard',
    element: <FriendCard />,
  },
  {
    path: '/:username/:category/bluffcard',
    element: <BluffCard />,
  },
  {
    path: '/:username/:category/hellheavencard',
    element: <HellHeavenCard />,
  },
  {
    path: '/:username/:category/reputationcard',
    element: <ReputationCard />,
  },
  {
    path: '/:username/:category/impressioncard',
    element: <ImpressionCard />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/safety',
    element: <Safety />,
  },
  {
    path: '/collaboration',
    element: <Collab />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/hidden-gems-tips-tricks-for-the-lol-app',
    element: <Blog1 />,
  },
  {
    path: '/blog/uplift-your-community',
    element: <Blog2 />,
  },
  {
    path: '/blog/announcing-new-features-and-user-controls',
    element: <Blog3 />,
  },
  {
    path: '/blog/lol-response-to-ftc-settlement',
    element: <Blog4 />,
  },
  {
    path: '/blog/staying-safe-on-lol',
    element: <Blog5 />,
  },
  {
    path: '/blog/guide-to-online-privacy',
    element: <Blog6 />,
  },
  {
    path: '/blog/lol-request-procedures',
    element: <Blog7 />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <LoadingProvider>
          <LoadingIndicator />
          <SnackbarProvider>
            <RouterProvider router={router} />
          </SnackbarProvider>
        </LoadingProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>
);



reportWebVitals();
